import { useSearchParams } from 'react-router-dom';

import { hideChat, showChat } from './useHubSpotChatStore';

export const HUBSPOT_VIEW_TYPES = {
  contactSales: 'inappchatrequest',
  getHelp: 'ab_chat',
} as const;

type ChatType = (typeof HUBSPOT_VIEW_TYPES)[keyof typeof HUBSPOT_VIEW_TYPES];

export const useHubspotView = () => {
  const [, setSearchParams] = useSearchParams();

  const handleShowChat = (type: ChatType) => {
    if (window.HubSpotConversations) {
      setSearchParams(
        (prevParams) => {
          Object.values(HUBSPOT_VIEW_TYPES).forEach((key) => {
            prevParams.delete(key);
          });

          prevParams.append(type, 'true');

          return prevParams;
        },
        {
          replace: true,
        },
      );

      window.HubSpotConversations.widget.refresh({ openToNewThread: true });

      showChat();
    }
  };

  const handleCloseChat = () => {
    setSearchParams(
      (prevParams) => {
        Object.values(HUBSPOT_VIEW_TYPES).forEach((key) => {
          prevParams.delete(key);
        });

        return prevParams;
      },
      {
        replace: true,
      },
    );

    hideChat();
  };

  return {
    handleCloseChat,
    handleShowChat,
  };
};
